import {TrackableEntity} from '../fms.core/data/ChangeTrackable';
import { IDictionary } from '../fms.core/data/TrackingModule';
import { DBMappingInfo } from './data/DBMappingInfo';

export class MemoComments extends TrackableEntity {
    id: number = 0;
    comment : string = '';
    u1Date: string | null = null;
    u1ID: string = '';
    u2Date: string | null = null;
    u2ID: string = '';
    updatedDesc: string = '';
    createdDesc: string = '';
    tbId: number = 0;
    commentTitle: string = '';

    constructor(init?:Partial<MemoComments>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'tbId');
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return MemoComments.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_MEMOCOMMENTS' }),
        'tbId': new DBMappingInfo({ field: 'F_TBID', table: 'T_MEMOCOMMENTS' }),
        'comment': new DBMappingInfo({ field: 'F_Comment', table: 'T_MEMOCOMMENTS' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_MEMOCOMMENTS' }),
        'u2ID': new DBMappingInfo({ field: 'F_U2ID', table: 'T_MEMOCOMMENTS' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_MEMOCOMMENTS' }),
        'u1ID': new DBMappingInfo({ field: 'F_U1ID', table: 'T_MEMOCOMMENTS'}),
        'commentTitle': new DBMappingInfo({ field: 'F_CommentTitle', table: 'T_MEMOCOMMENTS'}),
    };
}
